import { filter, prop } from 'ramda';
import flags from '@/flags';
export var enabledLanguages = function enabledLanguages() {
  return filter(prop('enabled'), flags.languages);
};